
//grab the elements for the icon and the input field for the password
const passwordIcon = document.getElementById("password-icon");
const passwordField = document.getElementById("provider-login-password");

//if icon exists on the page attach the eventListener 
if (passwordIcon)
{
    passwordIcon.addEventListener("click", togglePasswordVisiblity);
}

function togglePasswordVisiblity()
{
    //Check to see if the password field type is set to password
    passwordField.type = (passwordField.type !== "password") ? "password" : "text";
}